import React, { useState, useRef, useEffect, useContext } from "react";
import { getTableData } from "../../services/summaryReportsService";
import { ExtendedTableChart } from "../charts/ExtendedTableChart";
import { MonthNavigator } from "./MonthNavigator";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { ChartContainerMessage } from "./ChartContainerMessage";
import {
	getDateFromEpoch,
	getMonthAbbreviation,
	getDateOrdinal,
} from "../../services/dateService";

export const ExtendedTableChartContainer = ({ code }) => {
	const [dataSet, setDataSet] = useState([]);

	const [def, setDef] = useState(null);
	const [hasErrored, setHasErrored] = useState(false);

	let currentDate = dataSet.date ?? null;

	const mounted = useRef(false);

	const getData = (dateToGet) => {
		const then = (responseData) => {
			if (mounted.current === true) {
				currentDate = responseData.data.date;

				if (responseData.data.dueDate) {
					const dateFromEpoch = getDateFromEpoch(responseData.data.dueDate);
					const date = dateFromEpoch.getDate();
					const ordinal = getDateOrdinal(date);
					const month = getMonthAbbreviation(dateFromEpoch.getMonth());
					const year = dateFromEpoch.getFullYear();

					responseData.data.title = `${date}${ordinal} ${month} ${year}`;
				}

				setDataSet(responseData.data);
				setDef(responseData.def);
			}
		};

		if (dateToGet === null) {
			getTableData(code)
				.then(then)
				.catch((e) => {
					if (mounted.current === true) {
						setHasErrored(true);
					}
				});
		} else {
			getTableData(code, dateToGet)
				.then(then)
				.catch((e) => {
					if (mounted.current === true) {
						setHasErrored(true);
					}
				});
		}
	};

	useEffect(() => {
		mounted.current = true;
		getData(currentDate);

		return () => {
			mounted.current = false;
		};
	}, []);

	const first = () => {
		if (dataSet.nav.first === currentDate) {
			return;
		}
		getData(dataSet.nav.first);
	};

	const back = () => {
		if (dataSet.nav.prev === null) {
			return;
		}
		getData(dataSet.nav.prev);
	};

	const next = () => {
		if (dataSet.nav.next === null) {
			return;
		}
		getData(dataSet.nav.next);
	};

	const last = () => {
		if (dataSet.nav.last === currentDate) {
			return;
		}
		getData(dataSet.nav.last);
	};

	if (hasErrored === true) {
		return (
			<div className={"relative"}>
				<MonthNavigator
					heading={dataSet === null ? "Loading" : dataSet.title}
					first={first}
					back={back}
					next={next}
					last={last}
					nav={dataSet ? dataSet.nav : null}
				/>
				<ChartContainerMessage
					message={"There is no information to display for this period"}
				/>
			</div>
		);
	}

	if (def === null) {
		return <LoadingSpinner />;
	}

	//const gradient = `${cardTheme.from()} ${cardTheme.via()}`;
	const gradient = "from-white via-white";

	return (
		<div className={"relative overflow-visible"} style={{ height: "100%" }}>
			<MonthNavigator
				heading={dataSet === null ? "Loading" : dataSet.title}
				first={first}
				back={back}
				next={next}
				last={last}
				nav={dataSet ? dataSet.nav : null}
			/>
			<div
				className={
					"h-full flex flex-col items-stretch relative  overflow-visible"
				}
			>
				<div>
					<div
						className={
							"absolute top-3 left-0 right-0 bottom-12 px-3 overflow-auto pb-10 flex flex-col"
						}
					>
						<ExtendedTableChart dataSet={dataSet} def={def} />
					</div>
					<div
						className={`block absolute z-20 bottom-10 h-10 px-3 w-full bg-gradient-to-t ${gradient}`}
					>
						{" "}
					</div>
				</div>
			</div>
		</div>
	);
};
